import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

// Import Images
import multiUser from '../../assets/images/users/multi-user.jpg';

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  ModalBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  Form,
  ModalFooter,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Placeholder
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";

import companyPlaceholder from "../../assets/images/company-placeholder.svg";

//Import actions
import {
  getCompanies as onGetCompanies,
  addNewCompanies as onAddNewCompanies,
  updateCompanies as onUpdateCompanies,
  deleteCompanies as onDeleteCompanies,
} from "../../slices/thunks";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

// Export Modal
import ExportCSVModal from "../../Components/Common/ExportCSVModal";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { fileService } from "../../services/fileService";
import { companiesService } from "../../services/companiesService";
import { formatCNPJ, formatCPF } from "../../utils/formatters";
import { getCompanyPhaseStatus, mapBackendPhaseToFrontend } from "../../utils/phaseCompletion";

const CrmCompanies = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const selectLayoutState = (state: any) => state.Crm;
  const crmcompaniesData = createSelector(
    selectLayoutState,
    (state: any) => ({
      companies: state.companies,
      isCompaniesSuccess: state.isCompaniesSuccess,
    })
  );
  // Inside your component
  const {
    companies
  } = useSelector(crmcompaniesData);

  const [company, setCompany] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // if (companies && !companies.length) {
    setIsLoading(true);
    dispatch(onGetCompanies());
    // }
  }, [dispatch]);

  useEffect(() => {
    setCompany(companies);
    if (companies && companies.length >= 0) {
      setIsLoading(false);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      setCompany(companies);
      setIsEdit(false);
      setIsLoading(false);
    }
  }, [companies]);


  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<'partners' | 'company'>('company');
  const [detailTab, setDetailTab] = useState<'info' | 'address'>('info');
  const [showSenhaGov, setShowSenhaGov] = useState<{ [key: string]: boolean }>({});
  const [showAllCompanyInfo, setShowAllCompanyInfo] = useState<boolean>(false);

  //delete Company
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [deleteType, setDeleteType] = useState<'company' | 'partner'>('company');
  const [deleteTarget, setDeleteTarget] = useState<any>(null);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCompany(null);
      setSelectedImage('');
      setImgStore('');
    } else {
      setModal(true);
    }
  }, [modal]);

  // Delete Data
  const handleDeleteCompany = async () => {
    if (!deleteTarget) return;

    try {
      if (deleteType === 'partner') {
        // Delete partner - partner data includes companyId from mapping
        if (!deleteTarget.companyId) {
          toast.error(t('ID da empresa não encontrado'));
          return;
        }
        await companiesService.deletePartner(deleteTarget.companyId, deleteTarget.id);
        toast.success(t('Sócio excluído com sucesso'));
        // Refresh companies list
        dispatch(onGetCompanies());
      } else {
        // Delete company via Redux thunk
        dispatch(onDeleteCompanies(deleteTarget.id));
      }
      setDeleteModal(false);
      setDeleteTarget(null);
    } catch (error: any) {
      toast.error(error.message || t('Erro ao excluir'));
    }
  };

  const onClickDelete = (item: any, type: 'company' | 'partner' = 'company') => {
    setDeleteTarget(item);
    setDeleteType(type);
    setDeleteModal(true);
  };


  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: (company && company.id) || '',
      companyName: (company && company.companyName) || '',
      owner: (company && company.owner) || '',
      industryType: (company && company.industryType) || '',
      rating: (company && company.rating) || '',
      location: (company && company.location) || '',
      employee: (company && company.employee) || '',
      website: (company && company.website) || '',
      contact: (company && company.contact) || '',
      since: (company && company.since) || '',
      picture: (company && company.picture) || '',
    },
    validationSchema: Yup.object({
      picture: Yup.string().required(t("Please provide a picture")),
      companyName: Yup.string().required(t("Please Enter CompanyName")),
      owner: Yup.string().required(t("Please Enter Owner name")),
      industryType: Yup.string().required(t("Please Enter Industry Type")),
      rating: Yup.string().required(t("Please Enter Rating")),
      location: Yup.string().required(t("Please Enter Location")),
      employee: Yup.string().required(t("Please Enter Employee")),
      website: Yup.string().required(t("Please Enter Website")),
      contact: Yup.string().required(t("Please Enter Contact Email")),
      since: Yup.string().required(t("Please Enter Since")),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateCompany = {
          id: company ? company.id : 0,
          name: values.companyName,
          owner: values.owner,
          industryType: values.industryType,
          rating: parseFloat(values.rating),
          location: values.location,
          employeeCount: parseInt(values.employee) || 0,
          website: values.website,
          contactEmail: values.contact,
          foundedYear: parseInt(values.since) || new Date().getFullYear(),
          logoUrl: values.picture,
        };
        // update Company
        dispatch(onUpdateCompanies(updateCompany));
        validation.resetForm();
      } else {
        const newCompany = {
          name: values.companyName,
          owner: values.owner,
          industryType: values.industryType,
          rating: parseFloat(values.rating),
          location: values.location,
          employeeCount: parseInt(values.employee) || 0,
          website: values.website,
          contactEmail: values.contact,
          foundedYear: parseInt(values.since) || new Date().getFullYear(),
          logoUrl: values.picture,
        };
        // save new Company
        dispatch(onAddNewCompanies(newCompany));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Image

  const [imgStore, setImgStore] = useState<any>();
  const [selectedImage, setSelectedImage] = useState<any>();

  const handleClick = (item: any) => {
    const newData = [...imgStore, item];
    setImgStore(newData);
    validation.setFieldValue('picture', newData);
  };

  useEffect(() => {
    setImgStore((company && company.picture) || []);
  }, [company]);

  const handleImageChange = async (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      // Show preview immediately using FileReader
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);

      // Upload to R2 storage
      const result = await fileService.uploadFile(file, 'avatars/companies');

      // Set the R2 URL in the form
      validation.setFieldValue('picture', result.url);

      toast.success("Logo enviado com sucesso", { autoClose: 2000 });
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Falha ao enviar logo", { autoClose: 3000 });
      console.error("Error uploading file:", error);
    }
  };

  // Update Data
  const handleCompanyClick = useCallback((arg: any) => {
    const company = arg;
    const registrationType = company.registrationType?.toLowerCase();

    // Calculate which phases are complete based on company data
    const phaseStatus = getCompanyPhaseStatus(company);

    // Get the first incomplete phase (backend numbering)
    const backendPhase = phaseStatus.firstIncompletePhase;

    // Map backend phase to frontend phase for Abertura workflow
    const frontendPhase = mapBackendPhaseToFrontend(backendPhase, registrationType);

    // Navigate to the first incomplete phase
    // This ensures users are directed to where work is needed
    const targetUrl = `/apps-crm-companies/edit/${company.id}?type=${registrationType}&phase=${frontendPhase}`;
    navigate(targetUrl);
  }, [navigate]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall: any = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".companyCheckBox");

    if (checkall.checked) {
      ele.forEach((ele: any) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele: any) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState<boolean>(false);

  const deleteMultiple = () => {
    const checkall: any = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element: any) => {
      dispatch(onDeleteCompanies(element.value));
      setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };


  const deleteCheckbox = () => {
    const ele: any = document.querySelectorAll(".companyCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };


  // Partners Columns (Phase 1)
  const partnersColumns = useMemo(
    () => [
      {
        header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={(e) => { e.stopPropagation(); checkedAll(); }} />,
        cell: (cell: any) => {
          return <input type="checkbox" className="companyCheckBox form-check-input" value={cell.getValue()} onChange={() => deleteCheckbox()} onClick={(e: any) => e.stopPropagation()} />;
        },
        id: '#',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Id"),
        accessorKey: "companyNumber",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const companyNumber = cell.getValue();
          return companyNumber ? String(companyNumber).padStart(4, '0') : '-';
        },
      },
      {
        header: t("Empresa"),
        accessorKey: "companyName",
        enableColumnFilter: false,
      },
      {
        header: t("Nome"),
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: t("CPF"),
        accessorKey: "cpf",
        enableColumnFilter: false,
        cell: (cell: any) => formatCPF(cell.getValue()),
      },
      {
        header: t("Senha Gov"),
        accessorKey: "senhaGov",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const partner = cell.row.original;
          const senhaGov = cell.getValue();
          if (!senhaGov) return '-';

          const isVisible = showSenhaGov[partner.id] || false;
          return (
            <div className="d-flex align-items-center gap-2">
              <span>{isVisible ? senhaGov : '••••••••'}</span>
              <i
                className={`${isVisible ? 'ri-eye-off-line' : 'ri-eye-line'} cursor-pointer`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSenhaGov(prev => ({ ...prev, [partner.id]: !prev[partner.id] }));
                }}
                style={{ cursor: 'pointer' }}
              />
            </div>
          );
        },
      },
      {
        header: t("Cidade"),
        accessorKey: "address.city",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const partner = cell.row.original;
          return partner.address?.city || '-';
        },
      },
      {
        header: t("Entidade de Classe"),
        accessorKey: "entidadeClasse",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return cell.getValue() || '-';
        },
      },
      {
        header: t("Ação"),
        cell: (cell: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title="View">
                <Link to="#"
                  onClick={(e) => { e.stopPropagation(); const partnerData = cell.row.original; setInfo(partnerData); }}
                >
                  <i className="ri-eye-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Edit">
                <Link className="edit-item-btn" to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const partnerData = cell.row.original;
                    // Navigate to the company's wizard using companyId, open to Phase 1
                    if (partnerData.companyId) {
                      navigate(`/apps-crm-companies/edit/${partnerData.companyId}?phase=1`);
                    }
                  }}
                >
                  <i className="ri-pencil-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Delete">
                <Link
                  className="remove-item-btn"
                  onClick={(e) => { e.stopPropagation(); const partnerData = cell.row.original; onClickDelete(partnerData, 'partner'); }}
                  to="#"
                >
                  <i className="ri-delete-bin-fill align-bottom text-muted"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [checkedAll, t, navigate, showSenhaGov, setShowSenhaGov]
  );

  // Company Columns (Phase 2)
  const companyColumns = useMemo(
    () => [
      {
        header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={(e) => { e.stopPropagation(); checkedAll(); }} />,
        cell: (cell: any) => {
          return <input type="checkbox" className="companyCheckBox form-check-input" value={cell.getValue()} onChange={() => deleteCheckbox()} onClick={(e: any) => e.stopPropagation()} />;
        },
        id: '#',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Id"),
        accessorKey: "companyNumber",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const companyNumber = cell.getValue();
          return companyNumber ? String(companyNumber).padStart(4, '0') : '-';
        },
      },
      {
        header: t("Razão Social"),
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {(cell.row.original.logoUrl || cell.row.original.picture) ? <img
                  src={cell.row.original.logoUrl || cell.row.original.picture}
                  alt=""
                  className="avatar-xxs rounded-circle"
                /> :
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title bg-success-subtle text-success rounded-circle fs-13">
                      {cell.getValue()?.charAt(0) || ''}
                    </div>
                  </div>
                }
              </div>
              <div className="flex-grow-1 ms-2 name">
                {cell.getValue()}
              </div>
            </div>
          </>
        ),
      },
      {
        header: t("CNPJ"),
        accessorKey: "cnpj",
        enableColumnFilter: false,
        cell: (cell: any) => formatCNPJ(cell.getValue()),
      },
      {
        header: t("Status"),
        accessorKey: "registrationType",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const registrationType = cell.getValue();
          if (!registrationType) return '-';

          const type = registrationType.toLowerCase();
          const isAbertura = type === 'abertura';

          return (
            <span className={`badge ${isAbertura ? 'bg-primary' : 'bg-success'}`}>
              {isAbertura ? 'Abertura' : 'Portabilidade'}
            </span>
          );
        },
      },
      {
        header: t("Regime Tributário"),
        accessorKey: "taxRegime",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const regimes: any = { 1: 'Simples Nacional', 2: 'Lucro Presumido', 3: 'Lucro Real' };
          return regimes[cell.getValue()] || '-';
        },
      },
      {
        header: t("CNAE Principal"),
        accessorKey: "cnaePrincipal",
        enableColumnFilter: false,
      },
      {
        header: t("Email"),
        accessorKey: "email",
        enableColumnFilter: false,
      },
      {
        header: t("Telefone"),
        accessorKey: "phone",
        enableColumnFilter: false,
      },
      {
        header: t("Ação"),
        cell: (cell: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title="View">
                <Link to="#"
                  onClick={(e) => { e.stopPropagation(); const companyData = cell.row.original; setInfo(companyData); }}
                >
                  <i className="ri-eye-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Edit">
                <Link className="edit-item-btn" to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const companyData = cell.row.original;
                    handleCompanyClick(companyData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Delete">
                <Link
                  className="remove-item-btn"
                  onClick={(e) => { e.stopPropagation(); const companyData = cell.row.original; onClickDelete(companyData, 'company'); }}
                  to="#"
                >
                  <i className="ri-delete-bin-fill align-bottom text-muted"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleCompanyClick, checkedAll, t]
  );

  // Get current columns and data based on active tab
  const currentColumns = activeTab === 'partners' ? partnersColumns : companyColumns;
  const currentData = useMemo(() => {
    if (!Array.isArray(companies)) return [];

    if (activeTab === 'partners') {
      // Flatten all partners from all companies into a single array
      // and add company name to each partner
      return companies.flatMap((company: any) =>
        (company.partners || []).map((partner: any) => ({
          ...partner,
          companyName: company.name,
          companyId: company.id,
          companyNumber: company.companyNumber
        }))
      );
    } else {
      return companies;
    }
  }, [activeTab, companies]);

  // SideBar Company Deatail
  const [info, setInfo] = useState<any>(null);

  // Handle row click to show details
  const handleRowClick = useCallback((rowData: any) => {
    setInfo(rowData);
  }, []);

  // Auto-load first row when data changes
  useEffect(() => {
    if (currentData && currentData.length > 0 && currentData[0]?.id) {
      setInfo(currentData[0]);
    }
  }, [currentData]);

  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState<boolean>(false);

  document.title = "Companies | ProMédico Contabilidade";
  return (
    <React.Fragment>
      <div className="page-content">
        <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={companies}
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteCompany}
          onCloseClick={() => setDeleteModal(false)}
          message={deleteType === 'company'
            ? t('Tem certeza que deseja excluir esta empresa? ATENÇÃO: Todos os sócios vinculados a esta empresa também serão excluídos.')
            : undefined}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <Container fluid>
          <BreadCrumb title={t("Companies")} pageTitle={t("CRM")} />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="flex-grow-1">
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-success add-btn"
                          onClick={() => navigate('/apps-crm-companies/new?type=portabilidade')}
                        >
                          <i className="ri-exchange-line me-1 align-bottom"></i> {t("Portabilidade")}
                        </button>
                        <button
                          className="btn btn-primary add-btn"
                          onClick={() => navigate('/apps-crm-companies/new?type=abertura')}
                        >
                          <i className="ri-building-line me-1 align-bottom"></i> {t("Abertura")}
                        </button>
                      </div>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2">
                        {isMultiDeleteButton && <button className="btn btn-soft-secondary" id="remove-actions"
                          onClick={() => setDeleteModalMulti(true)}
                        ><i className="ri-delete-bin-2-line"></i></button>}
                        <button className="btn btn-secondary">
                          <i className="ri-filter-2-line me-1 align-bottom"></i>{" "}
                          {t("Filters")}
                        </button>
                        <button className="btn btn-soft-success" onClick={() => setIsExportCSV(true)}>{t("Export")}</button>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            href="#"
                            className="btn btn-soft-info btn-icon"
                            tag="button"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" href="#">
                              {t("All")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Week")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Month")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Year")}
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={9}>
              <Card id="companyList">
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className={`btn ${activeTab === 'partners' ? 'btn-primary' : 'btn-soft-primary'}`}
                      onClick={() => setActiveTab('partners')}
                    >
                      <i className="ri-team-line me-1"></i> {t("Fase 1: Sócios")}
                    </button>
                    <button
                      className={`btn ${activeTab === 'company' ? 'btn-primary' : 'btn-soft-primary'}`}
                      onClick={() => setActiveTab('company')}
                    >
                      <i className="ri-building-line me-1"></i> {t("Fase 2: Empresa")}
                    </button>
                  </div>
                </CardHeader>

                <CardBody className="pt-0">
                  <div>
                    {isLoading ? (
                      <div className="py-4">
                        {/* Search bar skeleton */}
                        <div className="mb-3">
                          <Placeholder animation="glow">
                            <Placeholder xs={4} />
                          </Placeholder>
                        </div>
                        {/* Table skeleton */}
                        <div className="table-responsive">
                          <table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={6} size="sm" /></Placeholder></th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...Array(5)].map((_, i) => (
                                <tr key={i}>
                                  <td><Placeholder animation="glow"><Placeholder xs={10} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={8} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={9} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={7} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={4} /></Placeholder></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        {/* Pagination skeleton */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <Placeholder animation="glow">
                            <Placeholder xs={3} size="sm" />
                          </Placeholder>
                          <Placeholder animation="glow">
                            <Placeholder xs={2} size="sm" />
                          </Placeholder>
                        </div>
                      </div>
                    ) : Array.isArray(currentData) && currentData.filter((c: any) => c && c.id).length > 0 ? (
                      <TableContainer
                        columns={currentColumns}
                        data={currentData.filter((c: any) => c && c.id)}
                        isGlobalFilter={true}
                        customPageSize={7}
                        divClass="table-responsive table-card mb-2"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        isCompaniesFilter={true}
                        SearchPlaceholder={activeTab === 'partners' ? t('Buscar sócio...') : t('Buscar empresa...')}
                        onRowClick={handleRowClick}
                      />
                    ) : (
                      <div className="noresult">
                        <div className="text-center py-4">
                          <div className="avatar-md mx-auto mb-4">
                            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-24">
                              <i className={activeTab === 'partners' ? "ri-team-line" : "ri-building-line"}></i>
                            </div>
                          </div>
                          <h5 className="mt-2">{t("Sorry! No Result Found")}</h5>
                          <p className="text-muted mb-0">
                            {activeTab === 'partners'
                              ? t("Nenhum sócio encontrado. Adicione uma empresa para começar.")
                              : t("Nenhuma empresa encontrada. Clique no botão acima para adicionar.")
                            }
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <Modal id="showModal" isOpen={modal} toggle={toggle} centered size="lg">
                    <ModalHeader className="bg-primary-subtle p-3" toggle={toggle}>
                      {!!isEdit ? t("Edit Company") : t("Add Company")}
                    </ModalHeader>
                    <Form className="tablelist-form" onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                      <ModalBody>
                        <input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div className="text-center">
                              <div className="position-relative d-inline-block">
                                <div className="position-absolute bottom-0 end-0">
                                  <Label htmlFor="company-logo-input" className="mb-0">
                                    <div className="avatar-xs cursor-pointer">
                                      <div className="avatar-title bg-light border rounded-circle text-muted">
                                        <i className="ri-image-fill"></i>
                                      </div>
                                    </div>
                                  </Label>
                                  <Input
                                    name="picture"
                                    className="form-control d-none" id="company-logo-input" type="file"
                                    accept="image/png, image/gif, image/jpeg" onChange={handleImageChange}
                                    invalid={validation.touched.picture && validation.errors.picture ? true : false}
                                  />
                                </div>
                                <div className="avatar-lg p-1" onClick={(item: any) => handleClick(item)}>
                                  <div className="avatar-title bg-light rounded-circle">
                                    <img src={selectedImage || validation.values.picture || multiUser} alt="multiUser" id="companylogo-img" className="avatar-md rounded-circle object-fit-cover" />
                                  </div>
                                </div>
                              </div>
                              <h5 className="fs-13 mt-3">{t("Company Logo")}</h5>
                              {validation.errors.picture && validation.touched.picture ? (
                                <FormFeedback type="invalid" className='d-block'> {validation.errors.picture} </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="name-field"
                                className="form-label"
                              >
                                {t("Company Name")}
                              </Label>

                              <Input
                                name="companyName"
                                id="customername-field"
                                className="form-control"
                                placeholder={t("Enter Company Name")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.companyName || ""}
                                invalid={
                                  validation.touched.companyName && validation.errors.companyName ? true : false
                                }
                              />
                              {validation.touched.companyName && validation.errors.companyName ? (
                                <FormFeedback type="invalid">{validation.errors.companyName}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="owner-field"
                                className="form-label"
                              >
                                {t("Owner Name")}
                              </Label>
                              <Input
                                name="owner"
                                id="owner-field"
                                className="form-control"
                                placeholder={t("Enter Owner Name")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.owner || ""}
                                invalid={
                                  validation.touched.owner && validation.errors.owner ? true : false
                                }
                              />
                              {validation.touched.owner && validation.errors.owner ? (
                                <FormFeedback type="invalid">{validation.errors.owner}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="industryType-field"
                                className="form-label"
                              >
                                {t("Industry Type")}
                              </Label>

                              <Input
                                name="industryType"
                                type="text"
                                className="form-control"
                                id="industryType-field"
                                placeholder={t("Enter Industry Type")}
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.industryType || ""}
                                invalid={
                                  validation.touched.industryType && validation.errors.industryType ? true : false
                                }
                              />
                              {validation.touched.industryType &&
                                validation.errors.industryType ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.industryType}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="rating-field"
                                className="form-label"
                              >
                                {t("Rating")}
                              </Label>
                              <Input
                                name="rating"
                                id="rating-field"
                                className="form-control"
                                placeholder={t("Enter Rating")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.rating || ""}
                                invalid={
                                  validation.touched.rating && validation.errors.rating ? true : false
                                }
                              />
                              {validation.touched.rating && validation.errors.rating ? (
                                <FormFeedback type="invalid">{validation.errors.rating}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="location-field"
                                className="form-label"
                              >
                                {t("Location")}
                              </Label>
                              <Input
                                name="location"
                                id="rating-field"
                                className="form-control"
                                placeholder={t("Enter Location")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location ? true : false
                                }
                              />
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback type="invalid">{validation.errors.location}</FormFeedback>
                              ) : null}

                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="employee-field"
                                className="form-label"
                              >
                                {t("Employee")}
                              </Label>
                              <Input
                                name="employee"
                                id="employee-field"
                                type="select"
                                className="form-select"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.employee || ""}
                                invalid={
                                  validation.touched.employee && validation.errors.employee ? true : false
                                }
                              >
                                <option value="">{t("Select employee range")}</option>
                                <option value="1-10">1-10</option>
                                <option value="10-50">10-50</option>
                                <option value="50-100">50-100</option>
                                <option value="100-300">100-300</option>
                                <option value="300-600">300-600</option>
                                <option value="600-1000">600-1000</option>
                                <option value="1000-2000">1000-2000</option>
                                <option value="2000-4000">2000-4000</option>
                                <option value="4000-6000">4000-6000</option>
                                <option value="6000+">6000+</option>
                              </Input>
                              {validation.touched.employee && validation.errors.employee ? (
                                <FormFeedback type="invalid">{validation.errors.employee}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="website-field"
                                className="form-label"
                              >
                                {t("Website")}
                              </Label>
                              <Input
                                name="website"
                                id="website-field"
                                className="form-control"
                                placeholder={t("Enter website")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.website || ""}
                                invalid={
                                  validation.touched.website && validation.errors.website ? true : false
                                }
                              />
                              {validation.touched.website && validation.errors.website ? (
                                <FormFeedback type="invalid">{validation.errors.website}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="contact-field"
                                className="form-label"
                              >
                                {t("Contact Email")}
                              </Label>
                              <Input
                                name="contact"
                                id="contact-field"
                                className="form-control"
                                placeholder={t("Enter Contact email")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.contact || ""}
                                invalid={
                                  validation.touched.contact && validation.errors.contact ? true : false
                                }
                              />
                              {validation.touched.contact && validation.errors.contact ? (
                                <FormFeedback type="invalid">{validation.errors.contact}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div>
                              <Label
                                htmlFor="since-field"
                                className="form-label"
                              >
                                {t("Since")}
                              </Label>
                              <Input
                                name="since"
                                id="since-field"
                                className="form-control"
                                placeholder={t("Enter since")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.since || ""}
                                invalid={
                                  validation.touched.since && validation.errors.since ? true : false
                                }
                              />
                              {validation.touched.since && validation.errors.since ? (
                                <FormFeedback type="invalid">{validation.errors.since}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button color="light" onClick={() => { setModal(false); }} > {t("Close")} </Button>
                          <Button type="submit" color="success" id="add-btn" >  {!!isEdit ? t("Update") : t("Add Company")} </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
            <Col xxl={3}>
              <Card id="company-view-detail">
                {isLoading ? (
                  <CardBody className="text-center">
                    <div className="position-relative d-inline-block">
                      <Placeholder animation="glow">
                        <Placeholder xs={12} className="avatar-md rounded-circle" style={{ height: '48px' }} />
                      </Placeholder>
                    </div>
                    <div className="mt-3">
                      <Placeholder animation="glow">
                        <Placeholder xs={8} className="mb-2" />
                        <Placeholder xs={6} size="sm" />
                      </Placeholder>
                    </div>
                    <div className="mt-4">
                      <Placeholder animation="glow">
                        <Placeholder xs={12} className="mb-2" />
                        <Placeholder xs={10} className="mb-2" />
                        <Placeholder xs={11} className="mb-2" />
                        <Placeholder xs={9} className="mb-2" />
                        <Placeholder xs={12} className="mb-2" />
                        <Placeholder xs={8} />
                      </Placeholder>
                    </div>
                  </CardBody>
                ) : (
                  <>
                    <CardBody className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="avatar-xl">
                          <div className="avatar-title bg-light rounded-circle">
                            {info && info.id && (info.logoUrl || info.picture) ? (
                              <img src={info.logoUrl || info.picture} alt="" className="avatar-lg rounded-circle object-fit-cover" />
                            ) : (
                              <img src={companyPlaceholder} alt="" className="avatar-lg" />
                            )}
                          </div>
                        </div>
                      </div>
                      {info && info.id ? (
                        <>
                          <h5 className="mt-3 mb-1">{info.name || info.companyName}</h5>
                          <p className="text-muted">{info.companyName ? t('Sócio') : (formatCNPJ(info.cnpj) || t('Empresa'))}</p>
                        </>
                      ) : (
                        <>
                          <h5 className="mt-3 mb-1">&nbsp;</h5>
                          <p className="text-muted">&nbsp;</p>
                        </>
                      )}
                    </CardBody>
                  </>
                )}

                {info && info.id && (
                  <div className="card-body pt-0">
                    {/* Show tabs for both companies and partners */}
                    <Nav tabs className="nav-tabs-custom nav-success mb-3">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={detailTab === 'info' ? 'active' : ''}
                          onClick={() => setDetailTab('info')}
                        >
                          <i className="ri-information-line me-1"></i>
                          {t('Informações')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={detailTab === 'address' ? 'active' : ''}
                          onClick={() => setDetailTab('address')}
                        >
                          <i className="ri-map-pin-line me-1"></i>
                          {t('Endereço')}
                        </NavLink>
                      </NavItem>
                      {/* Show Documents tab only for companies (not partners) */}
                      {!info.companyName && (
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/apps-crm-companies/edit/${info.id}?phase=3`)}
                          >
                            <i className="ri-folder-2-line me-1"></i>
                            {t('Documentos')}
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>

                    <TabContent activeTab={detailTab}>
                      {/* Information Tab (for both Company and Partner) */}
                      <TabPane tabId="info">
                        {info.companyName ? (
                          // Partner Information (has companyName added from flattening)
                          <div className="table-responsive table-card">
                            <table className="table table-borderless mb-0">
                              <tbody>
                                <tr>
                                  <td className="fw-medium">{t("Telefone")}</td>
                                  <td>{info.phone || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("RG")}</td>
                                  <td>{info.rg || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Email")}</td>
                                  <td>{info.email || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Data de Nascimento")}</td>
                                  <td>{info.dataNascimento ? new Date(info.dataNascimento).toLocaleDateString('pt-BR') : '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Entidade de Classe")}</td>
                                  <td>{info.entidadeClasse || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Senha Gov")}</td>
                                  <td>
                                    {info.senhaGov ? (
                                      <div className="d-flex align-items-center gap-2">
                                        <span>{showSenhaGov[info.id] ? info.senhaGov : '••••••••'}</span>
                                        <i
                                          className={`${showSenhaGov[info.id] ? 'ri-eye-off-line' : 'ri-eye-line'}`}
                                          onClick={() => setShowSenhaGov(prev => ({ ...prev, [info.id]: !prev[info.id] }))}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      </div>
                                    ) : '-'}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2} className="pt-3 pb-2 border-top">
                                    <h6 className="text-muted text-uppercase fw-semibold mb-0">
                                      <i className="ri-history-line me-1"></i>
                                      {t("Auditoria")}
                                    </h6>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Criado em")}</td>
                                  <td>{info.createdAt ? new Date(info.createdAt).toLocaleString('pt-BR') : '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Criado Por")}</td>
                                  <td>{info.createdByName || 'Sistema'}</td>
                                </tr>
                                {info.updatedAt && (
                                  <>
                                    <tr>
                                      <td className="fw-medium">{t("Ult. Atualização")}</td>
                                      <td>{new Date(info.updatedAt).toLocaleString('pt-BR')}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Ult. Atual. Por")}</td>
                                      <td>{info.updatedByName || 'Sistema'}</td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          // Company Information
                          <div className="table-responsive table-card">
                            <table className="table table-borderless mb-0">
                              <tbody>
                                {/* Always visible fields */}
                                <tr>
                                  <td className="fw-medium">{t("Status")}</td>
                                  <td>
                                    <span className={`badge ${info.isActive ? 'bg-success' : 'bg-danger'}`}>
                                      {info.isActive ? 'Ativo' : 'Inativo'}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Data de Abertura")}</td>
                                  <td>{info.dataAbertura ? new Date(info.dataAbertura).toLocaleDateString('pt-BR') : '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Tipo Empresarial")}</td>
                                  <td>
                                    {info.companyType ? ({ 1: 'Unipessoal LTDA', 2: 'Sociedade LTDA', 3: 'Individual', 4: 'Eireli', 5: 'MEI' }[info.companyType as 1 | 2 | 3 | 4 | 5] || info.companyType) : '-'}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Inscrição Municipal")}</td>
                                  <td>{info.municipalRegistration || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Regime Tributário")}</td>
                                  <td>
                                    {info.taxRegime ? ({ 1: 'Simples Nacional', 2: 'Lucro Presumido', 3: 'Lucro Real' }[info.taxRegime as 1 | 2 | 3] || '-') : '-'}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Segmento")}</td>
                                  <td>{info.segmento || '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Ramo de Atividade")}</td>
                                  <td>{info.ramoAtividadeNome || '-'}</td>
                                </tr>

                                {/* Conditional fields based on tax regime - always visible */}
                                {info.taxRegime === 1 && (
                                  <>
                                    <tr>
                                      <td className="fw-medium">{t("Código Simples")}</td>
                                      <td>{info.simplesCode || '-'}</td>
                                    </tr>
                                    {info.anexo && (
                                      <tr>
                                        <td className="fw-medium">{t("Anexo do Simples Nacional")}</td>
                                        <td>Anexo {info.anexo}</td>
                                      </tr>
                                    )}
                                  </>
                                )}

                                {/* Expandable fields - hidden behind "Mostrar mais" */}
                                {showAllCompanyInfo && (
                                  <>
                                    <tr>
                                      <td colSpan={2} className="pt-3 pb-2 border-top">
                                        <h6 className="text-muted text-uppercase fw-semibold mb-0">
                                          <i className="ri-file-list-line me-1"></i>
                                          {t("Informações Adicionais")}
                                        </h6>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("CNAE Secundário")}</td>
                                      <td>{info.cnaeSecondary || '-'}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("NIRE")}</td>
                                      <td>{info.nire || '-'}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Inscrição Estadual")}</td>
                                      <td>{info.stateRegistration || '-'}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Entidade Profissional")}</td>
                                      <td>{info.professionalEntity || '-'}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Faixa de Funcionários")}</td>
                                      <td>
                                        {info.employeeRange ? ({ 1: '1-10', 2: '11-50', 3: '51-200', 4: '201-500', 5: '500+' }[info.employeeRange as 1 | 2 | 3 | 4 | 5] || info.employeeRange) : '-'}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Porte")}</td>
                                      <td>{info.porte || '-'}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Capital Social")}</td>
                                      <td>
                                        {info.capitalSocial
                                          ? `R$ ${parseFloat(info.capitalSocial).toLocaleString('pt-BR', {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}`
                                          : '-'}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Senha NF")}</td>
                                      <td>{info.invoicePassword ? '••••••••' : '-'}</td>
                                    </tr>
                                    {info.observacao && (
                                      <tr>
                                        <td className="fw-medium" style={{ verticalAlign: 'top' }}>{t("Observações")}</td>
                                        <td style={{ whiteSpace: 'pre-wrap' }}>{info.observacao}</td>
                                      </tr>
                                    )}
                                  </>
                                )}

                                {/* Show more/less button */}
                                <tr>
                                  <td colSpan={2} className="text-center pt-3">
                                    <Button
                                      color="link"
                                      size="sm"
                                      className="text-decoration-none"
                                      onClick={() => setShowAllCompanyInfo(!showAllCompanyInfo)}
                                    >
                                      {showAllCompanyInfo ? (
                                        <>
                                          <i className="ri-arrow-up-s-line me-1"></i>
                                          {t("Mostrar menos")}
                                        </>
                                      ) : (
                                        <>
                                          <i className="ri-arrow-down-s-line me-1"></i>
                                          {t("Mostrar mais")}
                                        </>
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2} className="pt-3 pb-2 border-top">
                                    <h6 className="text-muted text-uppercase fw-semibold mb-0">
                                      <i className="ri-history-line me-1"></i>
                                      {t("Auditoria")}
                                    </h6>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Criado em")}</td>
                                  <td>{info.createdAt ? new Date(info.createdAt).toLocaleString('pt-BR') : '-'}</td>
                                </tr>
                                <tr>
                                  <td className="fw-medium">{t("Criado Por")}</td>
                                  <td>{info.createdByName || 'Sistema'}</td>
                                </tr>
                                {info.updatedAt && (
                                  <>
                                    <tr>
                                      <td className="fw-medium">{t("Ult. Atualização")}</td>
                                      <td>{new Date(info.updatedAt).toLocaleString('pt-BR')}</td>
                                    </tr>
                                    <tr>
                                      <td className="fw-medium">{t("Ult. Atual. Por")}</td>
                                      <td>{info.updatedByName || 'Sistema'}</td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </TabPane>

                      {/* Address Tab (for both Company and Partner) */}
                      <TabPane tabId="address">
                        <div className="table-responsive table-card">
                          <table className="table table-borderless mb-0">
                            <tbody>
                              {info.companyName ? (
                                // Partner address (has companyName added from flattening)
                                <>
                                  {info.address && (
                                    <>
                                      {info.address.street && (
                                        <tr>
                                          <td className="fw-medium">{t("Rua")}</td>
                                          <td>{info.address.street}</td>
                                        </tr>
                                      )}
                                      {info.address.number && (
                                        <tr>
                                          <td className="fw-medium">{t("Número")}</td>
                                          <td>{info.address.number}</td>
                                        </tr>
                                      )}
                                      {info.address.complement && (
                                        <tr>
                                          <td className="fw-medium">{t("Complemento")}</td>
                                          <td>{info.address.complement}</td>
                                        </tr>
                                      )}
                                      {info.address.neighborhood && (
                                        <tr>
                                          <td className="fw-medium">{t("Bairro")}</td>
                                          <td>{info.address.neighborhood}</td>
                                        </tr>
                                      )}
                                      {info.address.city && (
                                        <tr>
                                          <td className="fw-medium">{t("Cidade")}</td>
                                          <td>{info.address.city}</td>
                                        </tr>
                                      )}
                                      {info.address.state && (
                                        <tr>
                                          <td className="fw-medium">{t("Estado")}</td>
                                          <td>{info.address.state}</td>
                                        </tr>
                                      )}
                                      {info.address.cep && (
                                        <tr>
                                          <td className="fw-medium">{t("CEP")}</td>
                                          <td>{info.address.cep}</td>
                                        </tr>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                // Company headquarters address
                                <>
                                  <tr>
                                    <td className="fw-medium">{t("CEP")}</td>
                                    <td>{info.hqCep || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Rua")}</td>
                                    <td>{info.hqStreet || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Número")}</td>
                                    <td>{info.hqNumber || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Complemento")}</td>
                                    <td>{info.hqComplement || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Bairro")}</td>
                                    <td>{info.hqNeighborhood || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Cidade")}</td>
                                    <td>{info.hqCity || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Estado")}</td>
                                    <td>{info.hqState || '-'}</td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2} className="pt-3 pb-2 border-top">
                                      <h6 className="text-muted text-uppercase fw-semibold mb-0">
                                        <i className="ri-history-line me-1"></i>
                                        {t("Auditoria")}
                                      </h6>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Criado em")}</td>
                                    <td>{info.createdAt ? new Date(info.createdAt).toLocaleString('pt-BR') : '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Criado Por")}</td>
                                    <td>{info.createdByName || 'Sistema'}</td>
                                  </tr>
                                  {info.updatedAt && (
                                    <>
                                      <tr>
                                        <td className="fw-medium">{t("Ult. Atualização")}</td>
                                        <td>{new Date(info.updatedAt).toLocaleString('pt-BR')}</td>
                                      </tr>
                                      <tr>
                                        <td className="fw-medium">{t("Ult. Atual. Por")}</td>
                                        <td>{info.updatedByName || 'Sistema'}</td>
                                      </tr>
                                    </>
                                  )}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CrmCompanies;
